/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base';
// @ts-ignore
import { ReservationRead } from '../model';
// @ts-ignore
import { ReservationWrite } from '../model';
// @ts-ignore
import { ReservationsGetCollection200Response } from '../model';
/**
 * ReservationApi - axios parameter creator
 * @export
 */
export const ReservationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves the collection of Reservation resources.
     * @summary Retrieves the collection of Reservation resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [company]
     * @param {string} [userEmail]
     * @param {Array<string>} [userEmail2]
     * @param {string} [location]
     * @param {Array<string>} [location2]
     * @param {string} [createdAtBefore]
     * @param {string} [createdAtStrictlyBefore]
     * @param {string} [createdAtAfter]
     * @param {string} [createdAtStrictlyAfter]
     * @param {string} [updatedAtBefore]
     * @param {string} [updatedAtStrictlyBefore]
     * @param {string} [updatedAtAfter]
     * @param {string} [updatedAtStrictlyAfter]
     * @param {string} [daysDateBefore]
     * @param {string} [daysDateStrictlyBefore]
     * @param {string} [daysDateAfter]
     * @param {string} [daysDateStrictlyAfter]
     * @param {string} [roomsStartDateBefore]
     * @param {string} [roomsStartDateStrictlyBefore]
     * @param {string} [roomsStartDateAfter]
     * @param {string} [roomsStartDateStrictlyAfter]
     * @param {boolean} [active]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsGetCollection: async (
      page?: number,
      itemsPerPage?: number,
      company?: string,
      userEmail?: string,
      userEmail2?: Array<string>,
      location?: string,
      location2?: Array<string>,
      createdAtBefore?: string,
      createdAtStrictlyBefore?: string,
      createdAtAfter?: string,
      createdAtStrictlyAfter?: string,
      updatedAtBefore?: string,
      updatedAtStrictlyBefore?: string,
      updatedAtAfter?: string,
      updatedAtStrictlyAfter?: string,
      daysDateBefore?: string,
      daysDateStrictlyBefore?: string,
      daysDateAfter?: string,
      daysDateStrictlyAfter?: string,
      roomsStartDateBefore?: string,
      roomsStartDateStrictlyBefore?: string,
      roomsStartDateAfter?: string,
      roomsStartDateStrictlyAfter?: string,
      active?: boolean,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/reservations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (itemsPerPage !== undefined) {
        localVarQueryParameter['itemsPerPage'] = itemsPerPage;
      }

      if (company !== undefined) {
        localVarQueryParameter['company'] = company;
      }

      if (userEmail !== undefined) {
        localVarQueryParameter['user.email'] = userEmail;
      }

      if (userEmail2) {
        localVarQueryParameter['user.email[]'] = userEmail2;
      }

      if (location !== undefined) {
        localVarQueryParameter['location'] = location;
      }

      if (location2) {
        localVarQueryParameter['location[]'] = location2;
      }

      if (createdAtBefore !== undefined) {
        localVarQueryParameter['createdAt[before]'] = createdAtBefore;
      }

      if (createdAtStrictlyBefore !== undefined) {
        localVarQueryParameter['createdAt[strictly_before]'] =
          createdAtStrictlyBefore;
      }

      if (createdAtAfter !== undefined) {
        localVarQueryParameter['createdAt[after]'] = createdAtAfter;
      }

      if (createdAtStrictlyAfter !== undefined) {
        localVarQueryParameter['createdAt[strictly_after]'] =
          createdAtStrictlyAfter;
      }

      if (updatedAtBefore !== undefined) {
        localVarQueryParameter['updatedAt[before]'] = updatedAtBefore;
      }

      if (updatedAtStrictlyBefore !== undefined) {
        localVarQueryParameter['updatedAt[strictly_before]'] =
          updatedAtStrictlyBefore;
      }

      if (updatedAtAfter !== undefined) {
        localVarQueryParameter['updatedAt[after]'] = updatedAtAfter;
      }

      if (updatedAtStrictlyAfter !== undefined) {
        localVarQueryParameter['updatedAt[strictly_after]'] =
          updatedAtStrictlyAfter;
      }

      if (daysDateBefore !== undefined) {
        localVarQueryParameter['days.date[before]'] = daysDateBefore;
      }

      if (daysDateStrictlyBefore !== undefined) {
        localVarQueryParameter['days.date[strictly_before]'] =
          daysDateStrictlyBefore;
      }

      if (daysDateAfter !== undefined) {
        localVarQueryParameter['days.date[after]'] = daysDateAfter;
      }

      if (daysDateStrictlyAfter !== undefined) {
        localVarQueryParameter['days.date[strictly_after]'] =
          daysDateStrictlyAfter;
      }

      if (roomsStartDateBefore !== undefined) {
        localVarQueryParameter['rooms.startDate[before]'] =
          roomsStartDateBefore;
      }

      if (roomsStartDateStrictlyBefore !== undefined) {
        localVarQueryParameter['rooms.startDate[strictly_before]'] =
          roomsStartDateStrictlyBefore;
      }

      if (roomsStartDateAfter !== undefined) {
        localVarQueryParameter['rooms.startDate[after]'] = roomsStartDateAfter;
      }

      if (roomsStartDateStrictlyAfter !== undefined) {
        localVarQueryParameter['rooms.startDate[strictly_after]'] =
          roomsStartDateStrictlyAfter;
      }

      if (active !== undefined) {
        localVarQueryParameter['active'] = active;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a Reservation resource.
     * @summary Retrieves a Reservation resource.
     * @param {string} id Reservation identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsIdGet: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('reservationsIdGet', 'id', id);
      const localVarPath = `/api/reservations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Replaces the Reservation resource.
     * @summary Replaces the Reservation resource.
     * @param {string} id Reservation identifier
     * @param {ReservationWrite} reservationWrite The updated Reservation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsIdPut: async (
      id: string,
      reservationWrite: ReservationWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('reservationsIdPut', 'id', id);
      // verify required parameter 'reservationWrite' is not null or undefined
      assertParamExists(
        'reservationsIdPut',
        'reservationWrite',
        reservationWrite,
      );
      const localVarPath = `/api/reservations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        reservationWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates a Reservation resource.
     * @summary Creates a Reservation resource.
     * @param {ReservationWrite} reservationWrite The new Reservation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsPost: async (
      reservationWrite: ReservationWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'reservationWrite' is not null or undefined
      assertParamExists(
        'reservationsPost',
        'reservationWrite',
        reservationWrite,
      );
      const localVarPath = `/api/reservations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        reservationWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ReservationApi - functional programming interface
 * @export
 */
export const ReservationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ReservationApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves the collection of Reservation resources.
     * @summary Retrieves the collection of Reservation resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [company]
     * @param {string} [userEmail]
     * @param {Array<string>} [userEmail2]
     * @param {string} [location]
     * @param {Array<string>} [location2]
     * @param {string} [createdAtBefore]
     * @param {string} [createdAtStrictlyBefore]
     * @param {string} [createdAtAfter]
     * @param {string} [createdAtStrictlyAfter]
     * @param {string} [updatedAtBefore]
     * @param {string} [updatedAtStrictlyBefore]
     * @param {string} [updatedAtAfter]
     * @param {string} [updatedAtStrictlyAfter]
     * @param {string} [daysDateBefore]
     * @param {string} [daysDateStrictlyBefore]
     * @param {string} [daysDateAfter]
     * @param {string} [daysDateStrictlyAfter]
     * @param {string} [roomsStartDateBefore]
     * @param {string} [roomsStartDateStrictlyBefore]
     * @param {string} [roomsStartDateAfter]
     * @param {string} [roomsStartDateStrictlyAfter]
     * @param {boolean} [active]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reservationsGetCollection(
      page?: number,
      itemsPerPage?: number,
      company?: string,
      userEmail?: string,
      userEmail2?: Array<string>,
      location?: string,
      location2?: Array<string>,
      createdAtBefore?: string,
      createdAtStrictlyBefore?: string,
      createdAtAfter?: string,
      createdAtStrictlyAfter?: string,
      updatedAtBefore?: string,
      updatedAtStrictlyBefore?: string,
      updatedAtAfter?: string,
      updatedAtStrictlyAfter?: string,
      daysDateBefore?: string,
      daysDateStrictlyBefore?: string,
      daysDateAfter?: string,
      daysDateStrictlyAfter?: string,
      roomsStartDateBefore?: string,
      roomsStartDateStrictlyBefore?: string,
      roomsStartDateAfter?: string,
      roomsStartDateStrictlyAfter?: string,
      active?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ReservationsGetCollection200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.reservationsGetCollection(
          page,
          itemsPerPage,
          company,
          userEmail,
          userEmail2,
          location,
          location2,
          createdAtBefore,
          createdAtStrictlyBefore,
          createdAtAfter,
          createdAtStrictlyAfter,
          updatedAtBefore,
          updatedAtStrictlyBefore,
          updatedAtAfter,
          updatedAtStrictlyAfter,
          daysDateBefore,
          daysDateStrictlyBefore,
          daysDateAfter,
          daysDateStrictlyAfter,
          roomsStartDateBefore,
          roomsStartDateStrictlyBefore,
          roomsStartDateAfter,
          roomsStartDateStrictlyAfter,
          active,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ReservationApi.reservationsGetCollection']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves a Reservation resource.
     * @summary Retrieves a Reservation resource.
     * @param {string} id Reservation identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reservationsIdGet(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ReservationRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.reservationsIdGet(id, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ReservationApi.reservationsIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Replaces the Reservation resource.
     * @summary Replaces the Reservation resource.
     * @param {string} id Reservation identifier
     * @param {ReservationWrite} reservationWrite The updated Reservation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reservationsIdPut(
      id: string,
      reservationWrite: ReservationWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ReservationRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.reservationsIdPut(
          id,
          reservationWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ReservationApi.reservationsIdPut']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Creates a Reservation resource.
     * @summary Creates a Reservation resource.
     * @param {ReservationWrite} reservationWrite The new Reservation resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reservationsPost(
      reservationWrite: ReservationWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ReservationRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.reservationsPost(
          reservationWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ReservationApi.reservationsPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * ReservationApi - factory interface
 * @export
 */
export const ReservationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ReservationApiFp(configuration);
  return {
    /**
     * Retrieves the collection of Reservation resources.
     * @summary Retrieves the collection of Reservation resources.
     * @param {ReservationApiReservationsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsGetCollection(
      requestParameters: ReservationApiReservationsGetCollectionRequest = {},
      options?: AxiosRequestConfig,
    ): AxiosPromise<ReservationsGetCollection200Response> {
      return localVarFp
        .reservationsGetCollection(
          requestParameters.page,
          requestParameters.itemsPerPage,
          requestParameters.company,
          requestParameters.userEmail,
          requestParameters.userEmail2,
          requestParameters.location,
          requestParameters.location2,
          requestParameters.createdAtBefore,
          requestParameters.createdAtStrictlyBefore,
          requestParameters.createdAtAfter,
          requestParameters.createdAtStrictlyAfter,
          requestParameters.updatedAtBefore,
          requestParameters.updatedAtStrictlyBefore,
          requestParameters.updatedAtAfter,
          requestParameters.updatedAtStrictlyAfter,
          requestParameters.daysDateBefore,
          requestParameters.daysDateStrictlyBefore,
          requestParameters.daysDateAfter,
          requestParameters.daysDateStrictlyAfter,
          requestParameters.roomsStartDateBefore,
          requestParameters.roomsStartDateStrictlyBefore,
          requestParameters.roomsStartDateAfter,
          requestParameters.roomsStartDateStrictlyAfter,
          requestParameters.active,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a Reservation resource.
     * @summary Retrieves a Reservation resource.
     * @param {ReservationApiReservationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsIdGet(
      requestParameters: ReservationApiReservationsIdGetRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<ReservationRead> {
      return localVarFp
        .reservationsIdGet(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Replaces the Reservation resource.
     * @summary Replaces the Reservation resource.
     * @param {ReservationApiReservationsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsIdPut(
      requestParameters: ReservationApiReservationsIdPutRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<ReservationRead> {
      return localVarFp
        .reservationsIdPut(
          requestParameters.id,
          requestParameters.reservationWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates a Reservation resource.
     * @summary Creates a Reservation resource.
     * @param {ReservationApiReservationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reservationsPost(
      requestParameters: ReservationApiReservationsPostRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<ReservationRead> {
      return localVarFp
        .reservationsPost(requestParameters.reservationWrite, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for reservationsGetCollection operation in ReservationApi.
 * @export
 * @interface ReservationApiReservationsGetCollectionRequest
 */
export interface ReservationApiReservationsGetCollectionRequest {
  /**
   * The collection page number
   * @type {number}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly page?: number;

  /**
   * The number of items per page
   * @type {number}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly itemsPerPage?: number;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly company?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly userEmail?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly userEmail2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly location?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly location2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly createdAtBefore?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly createdAtStrictlyBefore?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly createdAtAfter?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly createdAtStrictlyAfter?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly updatedAtBefore?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly updatedAtStrictlyBefore?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly updatedAtAfter?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly updatedAtStrictlyAfter?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly daysDateBefore?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly daysDateStrictlyBefore?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly daysDateAfter?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly daysDateStrictlyAfter?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly roomsStartDateBefore?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly roomsStartDateStrictlyBefore?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly roomsStartDateAfter?: string;

  /**
   *
   * @type {string}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly roomsStartDateStrictlyAfter?: string;

  /**
   *
   * @type {boolean}
   * @memberof ReservationApiReservationsGetCollection
   */
  readonly active?: boolean;
}

/**
 * Request parameters for reservationsIdGet operation in ReservationApi.
 * @export
 * @interface ReservationApiReservationsIdGetRequest
 */
export interface ReservationApiReservationsIdGetRequest {
  /**
   * Reservation identifier
   * @type {string}
   * @memberof ReservationApiReservationsIdGet
   */
  readonly id: string;
}

/**
 * Request parameters for reservationsIdPut operation in ReservationApi.
 * @export
 * @interface ReservationApiReservationsIdPutRequest
 */
export interface ReservationApiReservationsIdPutRequest {
  /**
   * Reservation identifier
   * @type {string}
   * @memberof ReservationApiReservationsIdPut
   */
  readonly id: string;

  /**
   * The updated Reservation resource
   * @type {ReservationWrite}
   * @memberof ReservationApiReservationsIdPut
   */
  readonly reservationWrite: ReservationWrite;
}

/**
 * Request parameters for reservationsPost operation in ReservationApi.
 * @export
 * @interface ReservationApiReservationsPostRequest
 */
export interface ReservationApiReservationsPostRequest {
  /**
   * The new Reservation resource
   * @type {ReservationWrite}
   * @memberof ReservationApiReservationsPost
   */
  readonly reservationWrite: ReservationWrite;
}

/**
 * ReservationApi - object-oriented interface
 * @export
 * @class ReservationApi
 * @extends {BaseAPI}
 */
export class ReservationApi extends BaseAPI {
  /**
   * Retrieves the collection of Reservation resources.
   * @summary Retrieves the collection of Reservation resources.
   * @param {ReservationApiReservationsGetCollectionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public reservationsGetCollection(
    requestParameters: ReservationApiReservationsGetCollectionRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return ReservationApiFp(this.configuration)
      .reservationsGetCollection(
        requestParameters.page,
        requestParameters.itemsPerPage,
        requestParameters.company,
        requestParameters.userEmail,
        requestParameters.userEmail2,
        requestParameters.location,
        requestParameters.location2,
        requestParameters.createdAtBefore,
        requestParameters.createdAtStrictlyBefore,
        requestParameters.createdAtAfter,
        requestParameters.createdAtStrictlyAfter,
        requestParameters.updatedAtBefore,
        requestParameters.updatedAtStrictlyBefore,
        requestParameters.updatedAtAfter,
        requestParameters.updatedAtStrictlyAfter,
        requestParameters.daysDateBefore,
        requestParameters.daysDateStrictlyBefore,
        requestParameters.daysDateAfter,
        requestParameters.daysDateStrictlyAfter,
        requestParameters.roomsStartDateBefore,
        requestParameters.roomsStartDateStrictlyBefore,
        requestParameters.roomsStartDateAfter,
        requestParameters.roomsStartDateStrictlyAfter,
        requestParameters.active,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a Reservation resource.
   * @summary Retrieves a Reservation resource.
   * @param {ReservationApiReservationsIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public reservationsIdGet(
    requestParameters: ReservationApiReservationsIdGetRequest,
    options?: AxiosRequestConfig,
  ) {
    return ReservationApiFp(this.configuration)
      .reservationsIdGet(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Replaces the Reservation resource.
   * @summary Replaces the Reservation resource.
   * @param {ReservationApiReservationsIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public reservationsIdPut(
    requestParameters: ReservationApiReservationsIdPutRequest,
    options?: AxiosRequestConfig,
  ) {
    return ReservationApiFp(this.configuration)
      .reservationsIdPut(
        requestParameters.id,
        requestParameters.reservationWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Creates a Reservation resource.
   * @summary Creates a Reservation resource.
   * @param {ReservationApiReservationsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public reservationsPost(
    requestParameters: ReservationApiReservationsPostRequest,
    options?: AxiosRequestConfig,
  ) {
    return ReservationApiFp(this.configuration)
      .reservationsPost(requestParameters.reservationWrite, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
